import { registerLicense } from "@syncfusion/ej2-base";

// Mirror of EnterpriseEmail/web/src/lib/syncfusion.ts — kept in lock-step
// so every Syncfusion-bearing SPA follows the same register pattern.
//
// The `.env.local` copy has already been registered synchronously via the
// side-effect `registerSyncfusion.ts` import at the top of main.tsx. This
// export exists so a future server-fetched override (from an authenticated
// endpoint) can re-register without touching callers. Today it just
// re-applies the env value, which is idempotent.
export function initSyncfusion(): void {
    const key = import.meta.env.VITE_SYNCFUSION_LICENSE_KEY;
    if (key && key.length > 0) {
        registerLicense(key);
    }
    // With no key, Syncfusion shows a trial banner but all components work.
}
